import ServiceIcons from '@components/ServiceIcons'
import Icon from '@components/Icon'

const AccessModes = ({ access, geoLocation, links }) => (
    <div className="card green">
        <div className="card-header">
            <h3>
                <T>label.park.access.information</T>
            </h3>
            <hr />
        </div>
        <div className="card-block">
            <ServiceIcons
                services={access}
                render={({ type, title, index, key }) => (
                    <div key={index} className="mb-2">
                        <h4 className="d-flex align-items-center">
                            <Icon type={type} size="sm" className="mr-2" />
                            <T>{title}</T>
                        </h4>
                        <span>{access[key]}</span>
                    </div>
                )}
            />
            <ServiceIcons
                services={links}
                render={({ type, title, index, key, color, linkPrefix }) => (
                    <div key={index} className="mb-2">
                        <a href={linkPrefix + links[key]} target="_blank" rel="noopener noreferrer">
                            <h4 style={{ color }} className="d-flex align-items-center">
                                <Icon type={type} size="sm" className="mr-2" />
                                <T>{title}</T>
                            </h4>
                            <span style={{ color }}>{links[key]}</span>
                        </a>
                    </div>
                )}
            />
        </div>
        <div className="card-footer">
            <a
                rel="noopener noreferrer"
                className="btn btn--secondary"
                target="_blank"
                href={`https://www.google.com/maps/dir/?api=1&origin=My%20Location&destination=${geoLocation.x},${geoLocation.y}`}>
                <T>label.park.access.directions</T>
            </a>
        </div>
    </div>
)

export default AccessModes
